import useHeight from "../../hooks/useHeight";
import StyledButton from "./shared/StyledButton";
const buttonValues = {
  it: "REGISTRATI SUBITO!",
  uk: "SIGN UP NOW!",
  us: "SIGN UP NOW!",
  es: "¡REGÍSTRATE AHORA!",
  pt: "REGISTAR AGORA!",
};

const invitationTextValues = {
  it: "Risparmia fino all'80% sui tuoi abbonamenti preferiti!",
  uk: "Save up to 80% on your favourite subscriptions!",
  us: "Save up to 80% on your favorite subscriptions!",
  es: "Ahorra hasta el 80% en tus suscripciones favoritas! ",
  pt: "Economize até 80% em suas assinaturas favoritas!",
};

export const CustomLink = ({ href, locale }) => {
  const { GATSBY_BUILD_LANGUAGE } = process.env;
  return (
    <StyledButton
      text={buttonValues[GATSBY_BUILD_LANGUAGE || locale || "uk"]}
      link={href}
      style={{
        backgroundColor: "#FB4C68 !important",
      }}
    />
  );
};

export const ButtonParagraph = (props) => {
  const height = useHeight({ selector: ".CookieConsent", timeout: 7000 });
  return (
    <div
      {...props}
      css={{
        position: "fixed",
        width: "100%",
        margin: 0,
        left: 0,
        bottom: height || 0,
        zIndex: 5,
        padding: "18px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgb(134, 99, 219)",
      }}
    />
  );
};

const InvitationText = ({ locale }) => {
  const { GATSBY_BUILD_LANGUAGE } = process.env;
  return (
    <p
      style={{
        fontSize: "18px",
        padding: "0 8px",
        textAlign: "center",
        color: "white",
        fontWeight: 500,
      }}
    >
      {invitationTextValues[GATSBY_BUILD_LANGUAGE || locale || "uk"]}
    </p>
  );
};

export default ({ href, locale }) => (
  <ButtonParagraph id="blog-signup-button">
    <InvitationText locale={locale} />
    <CustomLink href={href} locale={locale} />
  </ButtonParagraph>
);
